import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"animation-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.4102 2L14.4871 7.11275L20.3005 8.45913L16.3888 12.9654L16.9047 18.9102L11.4102 16.5825L5.91577 18.9102L6.43171 12.9654L2.52001 8.45913L8.33334 7.11275L11.4102 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.4102 2L14.4871 7.11275L20.3005 8.45913L16.3888 12.9654L16.9047 18.9102L11.4102 16.5825L5.91577 18.9102L6.43171 12.9654L2.52001 8.45913L8.33334 7.11275L11.4102 2Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.9591 22.3559L18.8984 21.2953M21.6778 16.2407L20.6172 15.1801M13.381 22.3559L12.3203 21.2953","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Animation1 = Vue.extend<IconProps>({
  name: 'Animation1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'animation-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Animation1;
